import { Component, Input, ViewEncapsulation } from '@angular/core';

import { ShelvableBackend } from '../../services/ShelvableBackend/ShelvableBackend';
import { Utilities } from '../../services/Utilities';

@Component({
    selector: 'getting-started',
    templateUrl: './getting-started-popover.html',
    encapsulation: ViewEncapsulation.None
})
export class GettingStartedPopover {
    @Input() stage:string;
    @Input() topicName:string;

    gettingStartedStages:any;
    preventBubbling:($event:any) => void;

    constructor(shelvableBackend:ShelvableBackend) {
        this.gettingStartedStages = shelvableBackend.gettingStartedStages;
        this.preventBubbling = Utilities.preventBubbling;
    }
}



// WEBPACK FOOTER //
// ./web/static/components/getting-started-popover/getting-started-popover.ts